import type { ReactNode } from 'react';

/** #615 — the logo of a tournament as a banner, on the tournament card and
 *  at the top of the tournament page. Every shape of upload shows the same
 *  way: the image fills the full width, and the band crops it to its
 *  maximum height (operator, 2026-10-17: also a square logo). */
export default function TournamentBanner({ url, maxHeight, className = '', children }: {
  url: string;
  /** The maximum height of the band, for example `max-h-56`. */
  maxHeight: string;
  className?: string;
  /** An overlay, for example the button of the manager. */
  children?: ReactNode;
}) {
  return (
    <div className={`relative w-full overflow-hidden ${className}`}>
      {/* The name of the tournament is the heading under the banner: the
          image is decorative, so a screen reader does not read the name twice. */}
      <img src={url} alt="" className={`block w-full object-cover ${maxHeight}`} />
      {children}
    </div>
  );
}
